<template>
    <div class="container">
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-if="!canSeeFiles && !loading">
            <div class="alert--error" >
                <span > {{$t('pending_evaluations.expired')}} </span>
            </div>
        </div>

        <div v-else>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-7 col-xl-7">
                    <profile-intro-panel @profilePanelChange="onProfilePanelChange" />

                    <transition name="fade">
                        <profile-panel v-if="profilePanelVisible" />
                    </transition>

                    <div v-if="this.$store.state.profile.profile">
                        <files-panel v-if="hasFiles" />

                        <work-experience-panel v-if="hasJobFunctions" />
                        <reference-panel v-if="hasReferences" />
                        <job-interests-panel v-if="hasJobInterests" />

                        <studies-panel v-if="hasStudies" />
                        <courses-panel v-if="hasCourses" />

                        <competences-panel v-if="hasCompetences" />
                        <skills-panel v-if="hasSkills" />

                        <interests-panel v-if="hasInterests" />
                        <languages-panel v-if="hasLanguages" />
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
                    <evaluation-panel />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    import ProfileIntroPanel from '@/components/panels/profile/ProfileIntroPanel';
    import EvaluationPanel from '@/components/panels/profile/EvaluationPanel';
    import ProfilePanel from '@/components/panels/profile/ProfilePanel';
    import WorkExperiencePanel from '@/components/panels/profile/WorkExperiencePanel';
    import StudiesPanel from '@/components/panels/profile/StudiesPanel';
    import CoursesPanel from '@/components/panels/profile/CoursesPanel';
    import LanguagesPanel from '@/components/panels/profile/LanguagesPanel';
    import CompetencesPanel from '@/components/panels/profile/CompetencesPanel';
    import SkillsPanel from '@/components/panels/profile/SkillsPanel';
    import InterestsPanel from '@/components/panels/profile/InterestsPanel';
    import FilesPanel from '@/components/panels/profile/FilesPanel';
    import ReferencePanel from '@/components/panels/profile/ReferencePanel';
    import JobInterestsPanel from '@/components/panels/profile/JobInterestsPanel';
    import { profile } from '@/models';
    import { GET_PROFILE_EVALUATION } from '@/store/modules/profile';

    @Component({
        components: {
            ProfileIntroPanel,
            EvaluationPanel,
            ProfilePanel,
            WorkExperiencePanel,
            StudiesPanel,
            LanguagesPanel,
            CoursesPanel,
            CompetencesPanel,
            SkillsPanel,
            InterestsPanel,
            ReferencePanel,
            FilesPanel,
            JobInterestsPanel
        }
    })
    export default class Profile extends Vue {
        name = 'profile';

        profilePanelVisible = false;

        created() {
            const id = this.$route.params.user_id;
            const diploma = this.$route.params.diploma_id;
            const work_process = this.$route.params.work_process_id;
            const evaluation = this.$route.params.evaluation_id;
            this.$store.dispatch(GET_PROFILE_EVALUATION, { id, diploma, work_process, evaluation });
        }

        get loading() {
            return this.$store.state.profile.loading;
        }

        get canSeeFiles() {
            return !this.$store.state.profile.expired_evaluation;
        }

        get profile() {
            return this.$store.state.profile.profile;
        }

        get hasFiles(){
            return this.$store.state.profile.profile.files && this.$store.state.profile.profile.files.length > 0;
        }

        get hasJobFunctions() {
            return this.$store.state.profile.profile.job_functions && this.$store.state.profile.profile.job_functions.length > 0;
        }

        get hasReferences() {
            return this.$store.state.profile.profile.references && this.$store.state.profile.profile.references.length > 0;
        }
        get hasJobInterests() {
            return this.$store.state.profile.profile.job_interests && this.$store.state.profile.profile.job_interests.length > 0;
        }

        get hasStudies() {
            return this.$store.state.profile.profile.studies && this.$store.state.profile.profile.studies.length > 0;
        }

        get hasCourses() {
            return this.$store.state.profile.profile.courses && this.$store.state.profile.profile.courses.length > 0;
        }

        get hasCompetences() {
            return this.$store.state.profile.profile.competences && this.$store.state.profile.profile.competences.length > 0;
        }

        get hasSkills() {
            return this.$store.state.profile.profile.skills && this.$store.state.profile.profile.skills.length > 0;
        }

        get hasInterests() {
            return this.$store.state.profile.profile.interests && this.$store.state.profile.profile.interests.length > 0;
        }

        get hasLanguages() {
            return this.$store.state.profile.profile.languages && this.$store.state.profile.profile.languages.length > 0;
        }

        onProfilePanelChange(profilePanelVisible) {
            this.profilePanelVisible = profilePanelVisible;
        }

    }

    Vue.component('profile', Profile);
</script>



// WEBPACK FOOTER //
// src/pages/Profile.vue